import { EVENTS, externalLinkEvent } from "../../Tracking";
import { MenuListItem } from "@teamscheme/header-elements";
import LockOutlinedIcon from "@material-ui/icons/LockOutlined";
import LockOpenOutlinedIcon from "@material-ui/icons/LockOpenOutlined";
import AccountCircleOutlinedIcon from "@material-ui/icons/AccountCircleOutlined";
import { useAuth, IAuth0Context } from "../../auth/AuthProvider";
import StaticRoutes from "../../static-pages/StaticRoutes";
import { useCustomer } from "../../auth/CustomerProvider";
import MITT_NAF_URL from "../../auth/MittNafExternalUrl";
import { useBecomeMemberPath } from "../../membership/MembershipPaymentParameters";

function createLoggedInHeaderProps(): MenuListItem {
  const props: MenuListItem = {
    key: "MittNAF",
    text: "Mitt NAF",
    icon: {
      icon: <AccountCircleOutlinedIcon className="icon" />,
    },
    href: MITT_NAF_URL,
    trackEvent: externalLinkEvent(MITT_NAF_URL),
  };
  return props;
}

function createLoginHeaderProps(auth: IAuth0Context): MenuListItem {
  const props: MenuListItem = {
    key: "LoggInn",
    text: "Logg inn",
    icon: {
      icon: <LockOutlinedIcon className="icon hide" />,
      hoverIcon: <LockOpenOutlinedIcon className="hoverIcon hide" />,
    },
    trackEvent: EVENTS.HEADER.LOG_IN,
    onClick: () => {
      auth.loginWithRedirect({
        targetUrl: `${window.location.pathname}${window.location.search}`,
      });
    },
  };
  return props;
}

function createLogoutHeaderProps(auth: IAuth0Context): MenuListItem {
  const props: MenuListItem = {
    key: "LoggUt",
    text: "Logg ut",
    trackEvent: EVENTS.HEADER.LOG_OUT,
    onClick: () => auth.logout(),
  };
  return props;
}

export function useAuthHeaderElements() {
  const auth = useAuth();
  const customer = useCustomer();

  if (customer.isLoading) {
    const loading: MenuListItem = {
      key: "HenterBruker",
      text: "Henter bruker",
      isLoading: true,
    };
    return [loading];
  }
  if (customer.result && customer.isLoggedIn) {
    const loggedIn = createLoggedInHeaderProps();
    const logout = createLogoutHeaderProps(auth);
    if (!customer.result.hasMembership) {
      return [loggedIn, logout];
    }
    return [loggedIn, logout];
  }
  return [createLoginHeaderProps(auth)];
}

export function useStaticBecomeMemberMenuItem(): MenuListItem | null {
  const customer = useCustomer();
  if (customer.isLoading) return null;
  if (customer.result?.hasMembership) return null;
  return {
    key: "become-member",
    text: "Bli medlem",
    linkTo: StaticRoutes.becomeMember.path,
  };
}

export function useFlowBecomeMemberMenuItem(): MenuListItem | null {
  const customer = useCustomer();
  const linkTo = useBecomeMemberPath();
  if (customer.isLoading) return null;
  if (customer.result?.hasMembership) return null;

  return {
    key: "become-member",
    text: "Bli medlem",
    linkTo,
  };
}

export function createFaqHeaderProps(): MenuListItem {
  const props: MenuListItem = {
    key: "FAQ",
    text: "Vanlige spørsmål",
    linkTo: StaticRoutes.faq.path,
    trackEvent: EVENTS.HEADER.FAQ,
  };
  return props;
}

export function createAboutHeaderProps(): MenuListItem {
  const props: MenuListItem = {
    key: "About",
    text: "Slik fungerer det",
    linkTo: StaticRoutes.about.path,
    trackEvent: EVENTS.HEADER.FAQ,
  };
  return props;
}
